import React, { useEffect, useState } from "react";
import "./Intro.css";
import bgImage from "../photos/registon.webp";

const Intro = ({ onFinish }) => {
    const [fadeOut, setFadeOut] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setFadeOut(true);

            const exitTimer = setTimeout(() => {
                onFinish && onFinish();
            }, 1000);

            return () => clearTimeout(exitTimer);
        }, 4000);

        return () => clearTimeout(timer);
    }, [onFinish]);

    const firstWord = "ADAM";
    const secondWord = "VOYAGE";

    return (
        <div className={`intro-wrapper ${fadeOut ? "fade-out" : ""}`}>
            <img
                src={bgImage}
                alt="Registan Uzbekistan"
                className="intro-bg"
            />

            <div className="overlay"></div>

            <div className="intro-content">

                <h1 className="brand-title">

                    <div className="brand-line">
                        {firstWord.split("").map((letter, index) => (
                            <span
                                key={`a-${index}`}
                                className="letter"
                                style={{
                                    animationDelay: `${index * 0.08}s`,
                                }}
                            >
                                {letter}
                            </span>
                        ))}
                    </div>

                    <div className="brand-line">
                        {secondWord.split("").map((letter, index) => (
                            <span
                                key={`b-${index}`}
                                className="letter"
                                style={{
                                    animationDelay: `${0.45 + index * 0.08}s`,
                                }}
                            >
                                {letter}
                            </span>
                        ))}
                    </div>

                </h1>

                <p className="slogan">
                    Discover the Soul of Uzbekistan
                </p>

                <div className="loader-line"></div>

            </div>
        </div>
    );
};

export default Intro;